export const ACCENT = "#00A9A7";

export const getColors = (isDark) =>
  isDark
    ? {
        bg: "#29333E",
        border: "#646B72",
        text: "#F6F7F7",
        subText: "#9AA5B1",
        toggleBg: "#1F2933",
        toggleActive: "#3A4651",
        inRange: "#3A4651",
        hover: "#374550",
      }
    : {
        bg: "#F6F7F7",
        border: "#646B72",
        text: "#1F2933",
        subText: "#646B72",
        toggleBg: "#E4E7EB",
        toggleActive: "#FFFFFF",
        inRange: "#D9DBDD",
        hover: "#E4E7EB",
      };
